import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { SidebarProvider } from "../../context/SidebarContext";
import { ROUTES } from "../../constants";
import { logout } from "../../services/auth.service";
import {
  DashboardIcon,
  DiscountIcon,
  MenuIcon,
  OrdersIcon,
  ProfileIcon,
  RatingIcon,
  ReportIcon,
  WalletIcon,
} from "../../components/navigator/NavigationIcons";
import {
  LayoutContainer,
  Sidebar,
  SidebarHeader,
  Logo,
  CollapseButton,
  NavItems,
  NavItem,
  StyledNavLink,
  NavIcon,
  NavLabel,
  LogoutButton,
  MainContent,
  ContentArea,
  OutletContainer,
} from "../../styles/dashboardLayout";
import LogoutIcon from "@mui/icons-material/Logout";


const DashboardLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate(ROUTES.LOGIN);
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const navItems = [
    { path: ROUTES.DASHBOARD, label: "Dashboard", icon: <DashboardIcon /> },
    { path: ROUTES.MENU_MANAGEMENT, label: "Menu Management", icon: <MenuIcon /> },
    { path: ROUTES.ORDERS, label: "Orders", icon: <OrdersIcon /> },
    { path: ROUTES.DISCOUNT_VOUCHERS, label: "Discount Vouchers", icon: <DiscountIcon /> },
    { path: ROUTES.REPORTS, label: "Reports", icon: <ReportIcon /> },
    { path: ROUTES.RATINGS, label: "Ratings", icon: <RatingIcon /> },
    { path: ROUTES.WALLET, label: "Wallet", icon: <WalletIcon /> },
    { path: ROUTES.PROFILE, label: "Profile", icon: <ProfileIcon /> },
  ];

  const isMenuManagementActive = (itemPath: string) => {
    if (itemPath === ROUTES.MENU_MANAGEMENT) {
      return location.pathname === ROUTES.MENU_MANAGEMENT ||
             location.pathname.startsWith('/food/entry/') ||
             location.pathname.startsWith('/bundle-deal/entry/');
    }
    return location.pathname === itemPath;
  };

  return (
    <LayoutContainer>
      <Sidebar $collapsed={isSidebarCollapsed}>
        <SidebarHeader>
          <Logo $collapsed={isSidebarCollapsed}>
            {isSidebarCollapsed ? "S" : "Send"}
          </Logo>
          <CollapseButton onClick={toggleSidebar}>
            {isSidebarCollapsed ? "→" : "←"}
          </CollapseButton>
        </SidebarHeader>

        <NavItems>
          {navItems.map((item) => (
            <NavItem key={item.path}>
              <StyledNavLink
                to={item.path}
                className={isMenuManagementActive(item.path) ? "active" : ""}
                $collapsed={isSidebarCollapsed}
              >
                <NavIcon>{item.icon}</NavIcon>
                {!isSidebarCollapsed && <NavLabel>{item.label}</NavLabel>}
              </StyledNavLink>
            </NavItem>
          ))}
        </NavItems>

        <LogoutButton onClick={handleLogout} $collapsed={isSidebarCollapsed}>
          <NavIcon>
            <LogoutIcon />
          </NavIcon>
          {!isSidebarCollapsed && <span>Sign out</span>}
        </LogoutButton>
      </Sidebar>

      <MainContent $collapsed={isSidebarCollapsed}>
        <ContentArea>
          <OutletContainer>
            <SidebarProvider isSidebarCollapsed={isSidebarCollapsed}>
              <Outlet />
            </SidebarProvider>
          </OutletContainer>
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
};

export default DashboardLayout;